<div class="py-10 container m-auto w-full flex flex-col">
  <div class="w-full mb-4 flex border-b border-b-secondary-15 flex-row">
    <h1 class="text-primary-300 mb-4 text-4xl font-bold w-10/12">Гидравлический выбор</h1>
    <div class="w-2/12 mb-4">
      <img alt="" class="ml-auto" src="assets/GV.svg">
    </div>
  </div>
  <div class="w-full grid grid-cols-3 gap-8 mb-8 ">
    <button
      [class]="currentPath === SELECTION_STATES.SELECT ? 'border-b-4 border-b-primary-300 text-primary-300' : 'cursor-pointer border-b-2 border-b-secondary-100 text-secondary-200'"
      [disabled]="currentPath === SELECTION_STATES.SELECT"
      [routerLink]="APP_ROUTES.SELECTION"
      class="text-left">
      <h3 class="text-lg font-bold pb-4">1. Выбор системы</h3>
    </button>
    <button
      (click)="onEnterNavigate()"
      [class]="currentPath === SELECTION_STATES.ENTER ? 'border-b-4 border-b-primary-300 text-primary-300' : 'border-b-2 border-b-secondary-100 text-secondary-200'"
      [disabled]="currentPath === SELECTION_STATES.SELECT || currentPath === SELECTION_STATES.ENTER"
      class="text-left">
      <h3 class="text-lg font-bold pb-4">2. Ввод данных</h3>
    </button>
    <button
      [class]="currentPath === SELECTION_STATES.RESULT ? 'border-b-4 border-b-primary-300 text-primary-300' : 'border-b-2 border-b-secondary-100 text-secondary-200'"
      [disabled]="true"
      class="text-left">
      <h3 class="text-lg font-bold pb-4">3. Результат подбора</h3>
    </button>

  </div>
  <router-outlet (activate)="onPathChange($event)"></router-outlet>
</div>
<app-footer></app-footer>
